import type { MouseEvent } from 'react'
import { Trash2 } from 'lucide-react'

interface CardOverlayDeleteButtonProps {
  ariaLabel?: string
  dataTestId?: string
  onClick: (e: MouseEvent<HTMLButtonElement>) => void
}

/** Trash control for cinematic cards — matches audience error delete styling. */
export function CardOverlayDeleteButton({
  ariaLabel = 'Delete',
  dataTestId = 'card-overlay-delete-button',
  onClick,
}: CardOverlayDeleteButtonProps) {
  return (
    <button
      type="button"
      data-testid={dataTestId}
      aria-label={ariaLabel}
      onClick={onClick}
      className="flex h-8 w-8 items-center justify-center rounded-lg border-0 bg-destructive/30 text-white backdrop-blur-sm transition-colors hover:bg-destructive/60"
    >
      <Trash2 className="h-4 w-4" />
    </button>
  )
}
